import { useUserPreferences } from './useUserPreferences';

export type UIMode = 'beginner' | 'normal' | 'advanced';

/**
 * Hook pro zjisteni UI rezimu uzivatele.
 *
 * 3 rezimy:
 *   beginner  = pouze Prehled, Rostliny, Denik
 *   normal    = zakladni UI (zahrady, nadrze, cidla, vyziva)
 *   advanced  = vsechno vcetne analytiky, receptu, automatiky
 *
 * Zpetna kompatibilita: pokud ui_mode neni nastaveno,
 * odvodi se z puvodniho show_advanced_mode.
 */
export const useUIMode = (): { mode: UIMode; isBeginner: boolean; isAdvanced: boolean } => {
  const { preferences } = useUserPreferences();

  const mode: UIMode =
    preferences?.ui_mode ?? (preferences?.show_advanced_mode ? 'advanced' : 'normal');

  return {
    mode,
    isBeginner: mode === 'beginner',
    isAdvanced: mode === 'advanced',
  };
};

/** Zpetna kompatibilita — vrati true pokud je rezim 'advanced'. */
export const useIsAdvanced = (): boolean => useUIMode().isAdvanced;
